import { PageContextProviderProps } from "./schema";
import ClientContextProvider from "./client";
import ServerContextProvider from "./server";

const PageContextProvider: React.FC<PageContextProviderProps> = ({
    data,
    children,
}) => (
    <ServerContextProvider data={data}>
        <ClientContextProvider data={data}>{children}</ClientContextProvider>
    </ServerContextProvider>
);

export default PageContextProvider;
